import './App.scss';
import Phone from './components/Phone';
function App() {
  return (
    <div className="App">
      <Phone />

    </div>
  );
}

export default App;
